import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../auth";
import { Observable } from "rxjs";
import { Permissions } from "./api/models";

@Injectable({ providedIn: 'root' })
// protects routes from users without supervisor permissions
export class SupervisorAuthGuard {
  constructor(private authService: AuthService, private router: Router) {
  }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // First check if the user is signed in
    if (!this.authService.isSignedIn()) {
      console.warn(`SupervisorAuthGuard: '${state.url}' - User not signed in`, this.authService.tokenInfo, this.authService.userInfo);
      
      // Redirect to signin if not authenticated
      this.router.navigate(['/auth/signin'], {
        queryParams: { returnUrl: state.url }
      });
      
      return false;
    }
    
    // Then check if the user has supervisor permissions
    const userInfo = this.authService.userInfo;
    
    // Check if user has the IsSupervisor permission or SparkApp_Supervisor permission
    if (userInfo && 
        (userInfo.Permissions?.includes(Permissions.SparkApp_Supervisor))) {
      return true;
    }
    
    console.warn(`SupervisorAuthGuard: '${state.url}' - User lacks supervisor permissions`, this.authService.userInfo);
    
    // Redirect to unauthorized page or home
    this.router.navigate(['/not-authorized']);
    return false;
  }
} 